import { render, staticRenderFns } from "./wx-best-match-result.vue?vue&type=template&id=7569d28e&scoped=true&"
import script from "./wx-best-match-result.vue?vue&type=script&lang=js&"
export * from "./wx-best-match-result.vue?vue&type=script&lang=js&"
import style0 from "./wx-best-match-result.vue?vue&type=style&index=0&id=7569d28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569d28e",
  null
  
)

export default component.exports